import Icon from '@ant-design/icons';
import type { IconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { forwardRef } from 'react';

type Props = IconComponentProps;

export const SvgIcon = forwardRef<HTMLSpanElement, Props>(function SvgIcon(
  { size, style, ...props },
  ref,
) {
  return <Icon {...props} style={{ ...style, fontSize: size }} ref={ref} />;
});
